import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'
import CalendarSync from '../../components/atoms/CalendarSync/CalendarSync.jsx'
import { syncAllCalendarEvents } from '../../features/calendarSlice'
import { getDefaultSyncFromConnections } from '../../util/calendarProviders.js'
import CommonDeleteModal from '../../components/atoms/modal/CommonDeleteModal.jsx'
import { toastHelper } from '../../util/toastHelper.js'

import styles from './SyncAllModal.module.scss'

const SyncAllModal = () => {
	const dispatch = useDispatch()
	const connections = useSelector((state) => state.calendar.connections)

	const reduxDefault = React.useMemo(
		() => getDefaultSyncFromConnections(connections),
		[connections]
	)
	const [syncProviders, setSyncProviders] = React.useState(reduxDefault)

	const [isOpen, setIsOpen] = React.useState(false)

	const openModal = () => setIsOpen(true)
	const closeModal = () => setIsOpen(false)

	const handleSyncAll = () => {
		if (Object.values(syncProviders).filter(Boolean).length === 0) {
			toastHelper('Please select at least one provider to sync', 'error')
			return
		}
		dispatch(syncAllCalendarEvents({ providers: syncProviders }))
		closeModal()
	}

	return (
		<>
			<ButtonCustom variant="outlined" size="lg" onClick={openModal}>
				<img src="/images/calendar.svg" alt="calendar" /> Sync Task
			</ButtonCustom>

			{isOpen && (
				<CommonDeleteModal
					open={isOpen}
					handleClose={closeModal}
					Icon="/images/calendar.svg"
					ClassIcon={styles.calendarSyncAllIcon}
					heading="Sync Your Existing Tasks?"
					subHeading="We noticed you have tasks created before connecting your calendar. Would you like to sync them now so everything is in one place?"
					footerContent={
						<>
							<ButtonCustom
								variant="outlined"
								size="lg"
								onClick={closeModal}
							>
								Maybe Later
							</ButtonCustom>
							<ButtonCustom
								variant="default"
								size="lg"
								onClick={handleSyncAll}
							>
								Yes, Sync Now
							</ButtonCustom>
						</>
					}
					modalFooter={styles.calendarSyncAllFooter}
					subHeadingClass={styles.calendarSyncAllSubHeading}
				>
					<CalendarSync
						value={syncProviders}
						onChange={setSyncProviders}
						labelClassName={styles.calendarSyncLabel}
					/>
				</CommonDeleteModal>
			)}
		</>
	)
}

export default React.memo(SyncAllModal)
